import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageCountryService {
  constructor(private _httpClient: IesHttpClient) {}

  searchCountries(params: any) {
    return this._httpClient.get(AppUrl.searchCountries, params);
  }

  saveCountry(country: any) {
    return this._httpClient.post(AppUrl.saveCountry, country);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-country/adm-manage-country.service.ts